import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Box from '../../../../components/Box';
import ColumnChooser from '../../../../components/ColumnChooser';
import CustomMultiSelect from '../../../../components/CustomMultiSelect';
import CustomSingleSelect from '../../../../components/CustomSingleSelect';
import ExcelExportMenu from '../../../../components/ExcelExportMenu';
import { ExcelExportMode } from '../../../../helpers/excelExportRequest';
import Filters from '../../../../components/Filters';
import { ColumnChooserModel } from '../../../../models/common/ColumnChooserModel';
import { GetDailyReportListPagingAndFilterRequest } from '../../../../models/request/report/GetDailyReportListPagingAndFilterRequest';
import { RootState } from '../../../../redux/store';
import { CompanyService } from '../../../../services/CompanyService';
import { ConstantService } from '../../../../services/ConstantService';
import { MenuComponent } from '../../../../_metronic/assets/ts/components';
import moment from 'moment';
import { DeviceService } from '../../../../services/DeviceService';

interface Props {
    columns: ColumnChooserModel[]
    setColumns: React.Dispatch<React.SetStateAction<ColumnChooserModel[]>>
    getColumns: () => ColumnChooserModel[]
    pageName: string
    pageVersion: string
    excelExport: (mode: ExcelExportMode) => void
    filter: GetDailyReportListPagingAndFilterRequest
    getData: (_filter?: GetDailyReportListPagingAndFilterRequest | undefined) => Promise<void>
    setFilter: React.Dispatch<React.SetStateAction<GetDailyReportListPagingAndFilterRequest>>
}

const DailyReportListFilters = ({
    columns,
    setColumns,
    getColumns,
    pageName,
    pageVersion,
    excelExport,
    filter,
    getData,
    setFilter,
}: Props) => {
    const navigate = useNavigate();
    const auth = useSelector((state: RootState) => state.auth)

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
    }, [])

    return (
        <React.Fragment>
            <ColumnChooser
                columns={columns}
                getColumns={getColumns}
                pageName={pageName}
                pageVersion={pageVersion}
                setColumns={setColumns}
            />

            <ExcelExportMenu
                pageName={pageName}
                selectedCount={0}
                allowSelected={false}
                onExport={excelExport}
            />

            <Filters
                filter={filter}
                getData={getData}
                onReset={() => getData({
                    ...filter,
                    selectedDevice: undefined,
                    startDateStr: moment().format('YYYY-MM-DD 00:00'),
                    endDateStr: moment().format('YYYY-MM-DD 23:59'),
                    currentPage: 1,
                    skip: 0
                })}
            >
                <div className='mb-10'>
                    <label htmlFor="exampleFormControlInput1" className="form-label">Plaka</label>

                    <CustomSingleSelect
                        selectedValue={filter.selectedDevice}
                        onChange={(e) => {
                            setFilter({
                                ...filter,
                                selectedDevice: e
                            })
                        }}
                        onMenuOpen={() => DeviceService.getDeviceList()}
                        labelName='vehicleName'
                        valueName='deviceId'
                    />
                </div>

                <div className='mb-10'>
                    <label htmlFor="exampleFormControlInput1" className="form-label">Başlangıç Tarihi</label>
                    <input
                        type='datetime-local'
                        value={filter.startDateStr}
                        onChange={(e) => {
                            setFilter({
                                ...filter,
                                startDateStr: e.target.value
                            })
                        }}
                        className='form-control form-control-solid'
                    />
                </div>

                <div className='mb-10'>
                    <label htmlFor="exampleFormControlInput1" className="form-label">Bitiş Tarihi</label>
                    <input
                        type='datetime-local'
                        value={filter.endDateStr}
                        onChange={(e) => {
                            setFilter({
                                ...filter,
                                endDateStr: e.target.value
                            })
                        }}
                        className='form-control form-control-solid'
                    />
                </div>
            </Filters>
        </React.Fragment>
    )
}

export default DailyReportListFilters;